import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Table, DatePicker, Typography, Select } from "antd";
import { loggedInUser } from "core/redux/slice/authSlice";
import { useGetEmpContractReport } from "AppQuries/report/get-emp-contract-report";
import useTableExport from "core/Operations/useTableExport";
import { formatDate } from "core/Operations/dateFormat";
import { useTableSearch } from "core/Operations/useTableSearch";
import ReportTools from "Components/UI/ReportTools";
import TableTop from "Components/UI/TableTop";
import { all_routes } from "Router/all_routes";
import { Link } from "react-router-dom";
import {
  useFormattedDepartmentOption,
  useFormattedEmployees,
  useFormattedEmploymentTypeOption,
  useFormattedEmpTypeOption,
} from "core/Operations/formattedOption/useFormattedEmployeeOptions";
import { startOfMonth } from "date-fns";
import { format } from "date-fns";
// import Select from "react-select";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import { Download, Upload } from "react-feather";
import { useGetEmployeeDetailsQuery } from "AppQuries/employee/get-employee-details";
import { useGetEmployeeDetailsReportQuery } from "AppQuries/report/get-employee-details-report";
import { BackIcon } from "Components/UI/Icon/Icons";

const { RangePicker } = DatePicker;

const EmployeeDetails = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const [queryParams, setQueryParams] = useState({
    departmentCode: 0,
    employeeType: "",
  });

  const departmentOptions = useFormattedDepartmentOption(userData?.companyCode);
  const employeeTypeOptions = useFormattedEmpTypeOption(
    userData?.companyCode
  );
  const {
    data: reportData,
    isLoading,
    isError,
    isFetching,
    refetch: getReport,
  } = useGetEmployeeDetailsReportQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      userId: userData?.userID,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      ...queryParams,
      // departmentCode: queryParams?.departmentCode ?? 0,
    }
    // {
    //   enabled:
    //     !!userData?.companyCode &&
    //     !!userData?.locationCode &&
    //     !!queryParams?.departmentCode
    // }
  );

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueId",
      key: "uniqueId",
    },
    {
      title: "Employee Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Emp Type",
      dataIndex: "employeeType",
      key: "employeeType",
    },
    {
      title: "Department Name",
      dataIndex: "departmentname",
      key: "departmentname",
    },
    {
      title: "Designation Name",
      dataIndex: "designationName",
      key: "designationName",
    },

    // {
    //   title: "Location Name",
    //   dataIndex: "locationCode",
    //   key: "locationCode",
    // },
    // {
    //   title: "Contract Duration",
    //   dataIndex: "contractCode",
    //   key: "contractCode",
    // },
    // {
    //   title: "Contract Expiry Date",
    //   dataIndex: "contractExpiryDate",
    //   key: "contractExpiryDate",
    //   render: (date) => {
    //     return formatDate(date, "dd-MM-yyyy");
    //   },
    // },
  ];

  const processCertificationData = (employeeData) => {
    if (!employeeData || !employeeData.length) return [];

    // Find the maximum number of certificates any employee has
    const maxCertificates = Math.max(
      ...employeeData.map((emp) =>
        emp.certificationsDetails ? emp.certificationsDetails.length : 0
      ),
      0
    );

    // Create base employee fields (excluding certificationsDetails)
    const baseFields =
      employeeData.length > 0
        ? Object.keys(employeeData[0])
            .filter((key) => key !== "certificationsDetails")
            .map((key) => ({
              title: key.charAt(0).toUpperCase() + key.slice(1),
              dataIndex: key,
            }))
        : [];

    // Add certificate fields for each possible certificate
    const certificateFields = [];
    for (let i = 1; i <= maxCertificates; i++) {
      certificateFields.push(
        { title: `Cert ${i} Code`, dataIndex: `cert${i}Code` },
        { title: `Cert ${i} Name`, dataIndex: `cert${i}Name` },
        { title: `Cert ${i} Abbreviation`, dataIndex: `cert${i}Abbreviation` },
        { title: `Cert ${i} Number`, dataIndex: `cert${i}Number` },
        { title: `Cert ${i} Issue Date`, dataIndex: `cert${i}IssueDate` },
        { title: `Cert ${i} Expiry Date`, dataIndex: `cert${i}ExpiryDate` },
        // { title: `Cert ${i} Document`, dataIndex: `cert${i}Document` },
        // { title: `Cert ${i} Document Back`, dataIndex: `cert${i}DocumentBack` },
        { title: `Cert ${i} Remark`, dataIndex: `cert${i}Remark` },
        { title: `Cert ${i} Status`, dataIndex: `cert${i}Status` }
      );
    }

    return [...baseFields, ...certificateFields];
  };

  // Function to prepare data for export with certificate details
  const prepareExportData = (employeeData) => {
    if (!employeeData || !employeeData.length) return [];

    return employeeData.map((employee) => {
      // Create base data without certificate details
      const baseData = { ...employee };
      delete baseData.certificationsDetails;

      // Add certification details if they exist
      if (
        employee.certificationsDetails &&
        employee.certificationsDetails.length > 0
      ) {
        employee.certificationsDetails.forEach((cert, index) => {
          // const certNum = index + 1;
          baseData[`cert${index + 1}Code`] = cert.code || "";
          baseData[`cert${index + 1}Name`] = cert.courseName || "";
          baseData[`cert${index + 1}Abbreviation`] = cert.abbreviation || "";
          baseData[`cert${index + 1}Number`] = cert.certificateNumber || "";
          baseData[`cert${index + 1}IssueDate`] = cert.issueDate
            ? format(new Date(cert.issueDate), "yyyy-MM-dd")
            : "";
          baseData[`cert${index + 1}ExpiryDate`] = cert.expiryDate
            ? format(new Date(cert.expiryDate), "yyyy-MM-dd")
            : "";
          // baseData[`cert${index + 1}Document`] = cert.documentImage || "";
          // baseData[`cert${index + 1}DocumentBack`] =
          //   cert.documentImageBack || "";
          baseData[`cert${index + 1}Remark`] = cert.remark || "";
          baseData[`cert${index + 1}Status`] = cert.isActive
            ? "Active"
            : "Inactive";
        });
      }

      return baseData;
    });
  };

  const searchColumns = columns.map((column) => column.dataIndex);
  const { setSearchValue, filteredData } = useTableSearch(
    reportData || [],
    searchColumns
  );

  const employeeFields = processCertificationData(filteredData);
  const exportData = prepareExportData(filteredData);

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  // const employeeFields = reportData?.length
  //   ? Object.keys(reportData[0]).map((key) => ({
  //       title: key,
  //       dataIndex: key,
  //     }))
  //   : [];

  const { onEmployeeExcelDownload } = useTableExport({
    columns: employeeFields,
    data: exportData,
    fileName: "Employee Details Report",
    pdfTheme: "",
  });

  //   useEffect(() => {
  //     if (isMount) getEmployee();

  //     setIsMount(true);
  //   }, [queryParams?.departmentCode]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Employee Details Report</h4>
              {/* <h6>Employee Documents Expiry Summary Report</h6> */}
            </div>
          </div>

          {/* <ReportTools
            columns={columns}
            data={reportData}
            fileName={`Employee Contact Report`}
            pdfTheme="striped"
            refresh={getReport}
          /> */}
          <div className="page-btn">
            <button
              className="btn btn-added"
              type="button"
              onClick={onEmployeeExcelDownload}
            >
              <Download className="me-2" /> Download
            </button>
          </div>

          <div className="page-btn">
            <Link className="btn btn-secondary" to={all_routes.report_list}>
              <BackIcon className="me-2" />
              Back
            </Link>
          </div>
        </div>

        <div className="card table-list-card border-0">
          <div className="card-body">
            <TableTop
              onSearch={setSearchValue}
              toggleFilterVisibility={toggleFilterVisibility}
              isFilterVisible={isFilterVisible}
              showToggle={true}
            />
            <div
              className={`card${isFilterVisible ? " visible" : ""}`}
              id="filter_inputs"
              // style={{ display: isFilterVisible ? "block" : "none" }}
            >
              
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <div className="form-group d-grid">
                      <div className="form-floating">
                        <Select
                          className="form-control"
                          options={departmentOptions}
                          placeholder="Department"
                          onChange={(e) => {
                            updateQueryParams("departmentCode", e || 0);
                          }}
                          onClear={() => {
                            updateQueryParams("departmentCode", 0);
                          }}
                          allowClear
                        />
                        <label className="form-label">Department </label>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <div className="form-group d-grid">
                      <div className="form-floating">
                        <Select
                          className="form-control"
                          options={employeeTypeOptions}
                          placeholder="Employee Type"
                          onChange={(e) => {
                            updateQueryParams("employeeType", e || "");
                          }}
                          allowClear
                          onClear={() => {
                            updateQueryParams("employeeType", "");
                          }}
                        />
                        <label className="form-label">Employee Type </label>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-1 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">&nbsp;</label>
                      <Link
                        className="btn btn-filters ms-auto"
                        onClick={() => {
                          //   setSelectedRowKeys([]);
                          getReport();
                        }}
                        type="button"
                      >
                        <i data-feather="search" className="feather-search" />
                        {/* {isFetching ? (
                            <>
                              <i className="fas fa-spinner fa-spin me-2"></i>
                              Loading...
                            </>
                          ) : ( */}
                        <>Filter</>
                        {/* )} */}
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="table-responsive">
              <Table
                loading={isLoading}
                columns={columns}
                dataSource={filteredData}
                // rowKey={(record) =>
                //   `${record.employeeCode}`
                // }
                bordered
                pagination={true}
                // components={{
                //   header: {
                //     cell: (props) => (
                //       <th
                //         {...props}
                //         className="bg-secondary text-white text-center p-3"
                //       />
                //     ),
                //   },
                // }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeDetails;
